if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellPopin = document.getElementById('productPage_upsellModal');
        this.upsellPopinProducts = this.upsellPopin?.querySelectorAll(
          '.product__discounted-product',
        );
        this.stickyProductFormContainerDesktop = document.querySelector('.product-form[data-sticky-desktop]');
        this.stickyProductFormContainerMobile = document.querySelector('.product-form[data-sticky-mobile]');

        this.initUpsellPopin();
        this.initStickyForms();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        // this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        this.addProductToCart();

        if (this.upsellPopinProducts?.length) this.toggleUpsellPopin(true);
      }

      addProductToCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append(
          'sections',
          // this.cartNotification.getSectionsToRender().map(section => section.id),
          ['cart-drawer']
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    // this.cartNotification.renderContents(response);
                    // Open cart drawer
                    document.dispatchEvent(new CustomEvent('cart:opened'));
                    const cartDrawer = document.querySelector('.cart-drawer');
                    const cartOverlay = document.querySelector('.cart-overlay');
                    if (cartDrawer) {
                      cartDrawer.classList.add('active');
                      
                    }
                    if (cartOverlay) {
                      cartOverlay.classList.add('active');
                    }
                  });
                },
                {once: true},
              );
              quickAddModal.hide(true);
            } else {
              // this.cartNotification.renderContents(response);
              // Open cart drawer
              document.dispatchEvent(new CustomEvent('cart:opened'));
              const cartDrawer = document.querySelector('.cart-drawer');
              const cartOverlay = document.querySelector('.cart-overlay');
              if (cartDrawer) {
                cartDrawer.classList.add('active');
                
              }
              if (cartOverlay) {
                cartOverlay.classList.add('active');
              }
            }

            if (this.upsellPopinProducts?.length) {
              // this.cartNotification.close();
              const cartDrawer = document.querySelector('.cart-drawer');
              const cartOverlay = document.querySelector('.cart-overlay');
              if (cartDrawer) {
                cartDrawer.classList.remove('active');
                document.body.style.overflow = '';
              }
              if (cartOverlay) {
                cartOverlay.classList.remove('active');
              }
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      initStickyForms() {
        let stickyFormContainer;
        if (this.stickyProductFormContainerDesktop && window.innerWidth >= 750) 
          stickyFormContainer = this.stickyProductFormContainerDesktop;
        else if (this.stickyProductFormContainerMobile && window.innerWidth < 750) 
          stickyFormContainer = this.stickyProductFormContainerMobile;
        if (!stickyFormContainer) return;

        const footer = document.querySelector("footer");
        const header = document.querySelector("header");
        const stickyProductForm = stickyFormContainer.querySelector("form");
        
        let isStickyFormIntersecting = false;
        let isFooterIntersecting = false;
        let isHeaderIntersecting = false;
        
        const observerCallback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.target === stickyFormContainer) {
              isStickyFormIntersecting = entry.isIntersecting;
            } else if (entry.target === footer) {
              isFooterIntersecting = entry.isIntersecting;
            } else if (entry.target === header) {
              isHeaderIntersecting = entry.isIntersecting;
            }
            
            // Check if  footer / header or form are intersecting
            if (isFooterIntersecting || isStickyFormIntersecting || isHeaderIntersecting) {
              // Both sticky form and footer are intersecting
              stickyProductForm.classList.remove('sticked');
            } else {
              // Only one or neither is intersecting
              stickyProductForm.classList.add('sticked');
            }
          });
        };
        
        const observer = new IntersectionObserver(observerCallback, {
          root: null,
          threshold: 0.1,
        });
        
        observer.observe(stickyFormContainer);
        observer.observe(footer);
        observer.observe(header);
      }

      initUpsellPopin() {
        if (!this.upsellPopinProducts?.length) return;

        // Init close button
        const closeBtn = this.upsellPopin.querySelector('.product-upsell__close');
        if (closeBtn) closeBtn.addEventListener('click', () => this.closePopinAndShowCartNotif());

        // Init "No thanks" button
        const noThanksBtn = this.upsellPopin.querySelector('[data-action="close-popin"]');
        if (noThanksBtn)
          noThanksBtn.addEventListener('click', () => this.closePopinAndShowCartNotif());

        // Init popin "Add to cart" button
        const addBundleToCartBtn = this.upsellPopin.querySelector('[data-action="add-bundle"]');
        const originProductVariantId = addBundleToCartBtn.dataset.originProductVariantId;
        const targetProductVariantId = addBundleToCartBtn.dataset.targetProductVariantId;
        const targetProductUrl = addBundleToCartBtn.dataset.targetProductUrl;
        const productQuantity = Number(this.form.querySelector('.quantity__input')?.value) || 1;

        if (addBundleToCartBtn && originProductVariantId && targetProductVariantId) {
          // todo take into account previous quantities and decrement/increment the,
          addBundleToCartBtn.addEventListener('click', () => {
            fetch('/cart.js')
              .then(response => response.json())
              .then(response => {
                let currentLineItems = this.extractLineItems(response.items);

                // Remove origin_product quantity just added to cart
                if (currentLineItems.hasOwnProperty(originProductVariantId)) {
                  currentLineItems[originProductVariantId] -= productQuantity;
                }

                // Check if the targetProductVariantId exists in the object
                if (currentLineItems.hasOwnProperty(targetProductVariantId)) {
                  // If the key exists, increase its value by productQuantity
                  currentLineItems[targetProductVariantId] += productQuantity;
                } else {
                  // If the key doesn't exist, add a new key-value pair
                  currentLineItems[targetProductVariantId] = productQuantity;
                }

                const requestBody = JSON.stringify({
                  updates: currentLineItems,
                  sections: this.cartNotification.getSectionsToRender().map(section => section.id),
                  sections_url: targetProductUrl,
                });

                const config = fetchConfig('javascript');
                config.body = requestBody;

                return config;
              })
              .then(config => fetch(`${routes.cart_update_url}`, config))
              .then(response => response.json())
              .then(response => {
                this.toggleUpsellPopin(false);

                // Adapt reponse so that it holds the line item key of the just added bundle
                const responseWithKey = {
                  ...response,
                  key: response.items.find(
                    item => item.variant_id === Number(targetProductVariantId),
                  ).key,
                };

                this.cartNotification.renderContents(responseWithKey);

                if (response.status) {
                  this.handleErrorMessage(response.description);
                }
              });
          });
        }
      }

      toggleUpsellPopin(show) {
        // this.cartNotification.style.display = show ? 'none' : 'inherit';
        this.upsellPopin.setAttribute('open', show);
        document.body.style.overflowY = show ? 'hidden' : 'unset';
      }

      extractLineItems(cartJSON) {
        return cartJSON.reduce((accumulator, item) => {
          accumulator[item.variant_id] = (accumulator[item.variant_id] || 0) + item.quantity;
          return accumulator;
        }, {});
      }

      closePopinAndShowCartNotif() {
        this.toggleUpsellPopin(false);
        setTimeout(() => {
          // this.cartNotification.open();
          // Open cart drawer
          document.dispatchEvent(new CustomEvent('cart:opened'));
          const cartDrawer = document.querySelector('.cart-drawer');
          const cartOverlay = document.querySelector('.cart-overlay');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            
          }
          if (cartOverlay) {
            cartOverlay.classList.add('active');
          }
        }, 1000);
      }
    },
  );
}
